/* NOVA redesign · Dcentrify · 2026 */
(function () {
  if (window.__novaHome) return;
  window.__novaHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var html = document.documentElement;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function parse(txt) { return new DOMParser().parseFromString(txt, 'text/html'); }
  function withParam(url, key, val) { var u = new URL(url, location.origin); u.searchParams.set(key, val); return u.pathname + u.search; }

  /* ---------- overlays: menu, cart, filter drawers and the search screen ---------- */
  var openEl = null, lastFocus = null;
  function scrim() { return $('[data-nv-scrim]'); }
  function open(name) {
    var el = name === 'search' ? $('[data-nv-search]') : $('[data-nv-drawer="' + name + '"]');
    if (!el) return false;
    close();
    lastFocus = document.activeElement;
    el.classList.add('is-on'); el.setAttribute('aria-hidden', 'false');
    if (name !== 'search' && scrim()) scrim().classList.add('is-on');
    html.classList.add('nv-lock');
    openEl = el;
    if (name === 'search') { var q = $('[data-nv-q]', el); if (q) q.focus({ preventScroll: true }); }
    else setTimeout(function () { el.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('is-on'); openEl.setAttribute('aria-hidden', 'true');
    if (scrim()) scrim().classList.remove('is-on');
    html.classList.remove('nv-lock');
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-nv-open]');
    if (o) { if (open(o.getAttribute('data-nv-open'))) e.preventDefault(); if (o.dataset.nvOpen === 'cart') refreshCart(); return; }
    if (e.target.closest('[data-nv-close]') || e.target.closest('[data-nv-scrim]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- header search opens the full-screen search ---------- */
  function fromHeader(e) {
    var f = e.target.closest && e.target.closest('[data-nv-srch] input[name=q]');
    if (!f || !$('[data-nv-search]')) return;
    var v = f.value; f.blur(); open('search');
    var q = $('[data-nv-q]'); if (q && v) { q.value = v; liveSearch(v); }
  }
  document.addEventListener('click', fromHeader);
  document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('[data-nv-srch] input[name=q]') && !e.target.__ptr) fromHeader(e); });
  document.addEventListener('pointerdown', function (e) { if (e.target.matches && e.target.matches('[data-nv-srch] input[name=q]')) { e.target.__ptr = 1; setTimeout(function () { e.target.__ptr = 0; }, 400); } });
  var srT, srCtl, srGrid, srDefault;
  function liveSearch(term) {
    var grid = $('[data-nv-sr-grid]'), title = $('[data-nv-sr-title]'), all = $('[data-nv-sr-all]');
    if (!grid) return;
    if (srDefault == null) { srDefault = grid.innerHTML; srGrid = title.textContent; }
    term = term.trim();
    if (srCtl) srCtl.abort();
    if (!term) { grid.innerHTML = srDefault; title.textContent = srGrid; all.hidden = true; return; }
    grid.innerHTML = new Array(9).join('<div class="nv-skel"></div>');
    srCtl = window.AbortController ? new AbortController() : null;
    var url = ROOT + 'search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last&section_id=nova-grid-page';
    fetch(url, srCtl ? { signal: srCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (t) {
      var page = $('[data-nv-page]', parse(t));
      var n = page ? Number(page.dataset.total) : 0;
      var cards = page ? $$('.nv-pc', page).slice(0, 8) : [];
      title.textContent = n ? n + (n === 1 ? ' result' : ' results') + ' for "' + term + '"' : (cards.length ? 'No exact matches for "' + term + '", similar items' : 'No results for "' + term + '"');
      all.href = ROOT + 'search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
      all.hidden = !n;
      grid.innerHTML = '';
      if (!cards.length) { grid.innerHTML = srDefault; return; }
      cards.forEach(function (c) { grid.appendChild(c); });
    }).catch(function () {});
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-nv-q]')) return;
    clearTimeout(srT); var v = e.target.value; srT = setTimeout(function () { liveSearch(v); }, 260);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nv-term]'); if (!t) return;
    var q = $('[data-nv-q]'); if (!q || !$('[data-nv-search]').classList.contains('is-on')) return;
    e.preventDefault(); q.value = t.dataset.nvTerm; liveSearch(q.value); q.focus();
  });

  /* ---------- cart drawer ---------- */
  function cartSections() { return $$('[data-nv-cart-section]').map(function (el) { return el.dataset.nvCartSection; }); }
  function paintCart(sections, count) {
    Object.keys(sections || {}).forEach(function (id) {
      var host = $('[data-nv-cart-section="' + id + '"] [data-nv-cart-inner]'); if (!host || !sections[id]) return;
      var fresh = $('[data-nv-cart-inner]', parse(sections[id])); if (fresh) host.innerHTML = fresh.innerHTML;
    });
    if (count != null) $$('[data-nv-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = !count; });
  }
  function refreshCart() {
    var ids = cartSections(); if (!ids.length) return Promise.resolve();
    return fetch(ROOT + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (s) {
      return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { paintCart(s, c.item_count); });
    }).catch(function () {});
  }
  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: cartSections().join(',') }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          paintCart(res.sections, cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'nova', data: { source: 'nova', itemCount: cart.item_count } } }));
          if (!open('cart')) toast('Added to your cart');
          return cart;
        });
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nv-add]'); if (!b) return;
    e.preventDefault();
    addToCart([{ id: Number(b.dataset.nvAdd), quantity: 1 }], b).catch(function () { location.href = b.dataset.nvUrl || ROOT + 'cart'; });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nv-qty]'); if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-nv-cart-inner]'); if (box) box.style.opacity = '.6';
    fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.nvQty, quantity: Number(b.dataset.q), sections: cartSections().join(',') }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c.status && !c.sections) { toast(c.description || c.message || 'Could not update the cart'); return refreshCart(); } paintCart(c.sections, c.item_count); })
      .catch(function () { location.reload(); })
      .finally(function () { if (box) box.style.opacity = ''; });
  });

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'nv-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl.__t); toastEl.__t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- copy code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nv-copy]'); if (!b) return;
    var v = b.dataset.nvCopy, done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(v).then(done, done); else done();
  });

  /* ---------- newsletter: sign up in place, then show the code ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f.id !== 'NovaNewsletter' || !window.fetch || f.__nv) return;
    e.preventDefault();
    var btn = $('button[type=submit]', f); if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } }).then(function (r) {
      if (/challenge/.test(r.url)) throw new Error('challenge');
      return r.text();
    }).then(function (t) {
      var fresh = $('#NovaNewsletter', parse(t));
      if (!fresh) throw new Error('missing');
      f.innerHTML = fresh.innerHTML;
    }).catch(function () { f.__nv = 1; f.submit(); });
  });

  /* ---------- infinite product grids ---------- */
  function loader(host, opts) {
    var grid = $('[data-nv-items]', host), sent = $('[data-nv-sentinel]', host), end = $('[data-nv-end]', host);
    if (!grid || !sent || sent.__nv) return; sent.__nv = 1;
    var busy = false;
    function nextUrl() {
      if (sent.hasAttribute('data-done')) return null;
      var sec = sent.dataset.section || 'nova-grid-page';
      if (sent.dataset.next) return withParam(sent.dataset.next, 'section_id', sec);
      if (sent.dataset.url) return withParam(withParam(sent.dataset.url, 'page', sent.dataset.page || 2), 'section_id', sec);
      return null;
    }
    function finish() { sent.setAttribute('data-done', ''); if (end) end.hidden = false; }
    function more() {
      var url = nextUrl(); if (busy || !url) return;
      busy = true;
      var sk = document.createElement('div'); sk.style.display = 'contents'; sk.innerHTML = new Array(6).join('<div class="nv-skel"></div>'); grid.appendChild(sk);
      var token = host.__tok = (host.__tok || 0) + 1;
      fetch(url).then(function (r) { return r.text(); }).then(function (t) {
        if (token !== host.__tok) return;
        sk.remove();
        var page = $('[data-nv-page]', parse(t)); if (!page) return finish();
        $$('.nv-pc', page).forEach(function (c) { grid.appendChild(c); });
        var shown = grid.children.length, max = opts && opts.max;
        $$('[data-nv-shown]', host).forEach(function (s) { s.textContent = shown; });
        if (sent.dataset.next !== undefined) sent.dataset.next = page.dataset.next || '';
        else sent.dataset.page = Number(sent.dataset.page || 2) + 1;
        if (!page.dataset.next || (max && shown >= max)) finish();
      }).catch(function () { sk.remove(); }).finally(function () { busy = false; if (!sent.hasAttribute('data-done') && near()) more(); });
    }
    function near() { var r = sent.getBoundingClientRect(); return r.top < window.innerHeight + 900 && r.bottom > -900; }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) more(); }, { rootMargin: '900px 0px' }).observe(sent);
    var st; window.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { if (near()) more(); }, 120); }, { passive: true });
    host.__more = more;
  }

  /* point a loader at another collection (feed tabs, deal chips) */
  function swap(host, url, section, endTxt) {
    var sent = $('[data-nv-sentinel]', host), grid = $('[data-nv-items]', host), end = $('[data-nv-end]', host), link = $('[data-nv-end-link]', host), txt = $('[data-nv-end-txt]', host);
    if (!sent || !grid) return;
    host.__tok = (host.__tok || 0) + 1;
    grid.innerHTML = '';
    if (end) end.hidden = true;
    if (link && !host.hasAttribute('data-deals-only')) link.href = url;
    if (txt) { if (!txt.__orig) txt.__orig = txt.textContent; txt.textContent = endTxt || txt.__orig; }
    $$('[data-nv-showing]', host).forEach(function (x) { x.hidden = true; });
    delete sent.dataset.next; sent.dataset.url = url; sent.dataset.page = 1;
    if (section) sent.dataset.section = section; else delete sent.dataset.section;
    sent.removeAttribute('data-done');
    var top = host.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(html).getPropertyValue('--nv-stick')) || 0) - 10;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    if (host.__more) host.__more();
  }

  /* home feed tabs swap the collection behind the loader */
  function feed(host) {
    if (host.__nv) return; host.__nv = 1;
    loader(host, { max: Number(host.dataset.max) || 60 });
    var dt = $('[data-nv-dtabs]', host);
    host.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nv-feed-tab]'); if (!b || b.classList.contains('is-on')) return;
      $$('[data-nv-feed-tab]', host).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
      if (dt) { dt.hidden = !b.hasAttribute('data-deals'); $$('[data-nv-swap]', dt).forEach(function (x, i) { x.classList.toggle('is-on', i === 0); }); }
      swap(host, b.dataset.nvFeedTab, b.dataset.section);
    });
  }

  /* deal chips: one department's discounted items */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nv-swap]'); if (!b || b.classList.contains('is-on')) return;
    var host = b.closest('[data-nv-feed],[data-nv-plp]'); if (!host) return;
    $$('[data-nv-swap]', b.parentNode).forEach(function (x) { x.classList.toggle('is-on', x === b); });
    swap(host, b.dataset.nvSwap, b.dataset.section, b.dataset.end);
  });

  /* ---------- product page ---------- */
  function money(cents, fmt) {
    var n = cents / 100, s = n % 1 === 0 ? String(n) : n.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function pdp(root) {
    if (root.__nv) return; root.__nv = 1;
    var fmt = root.dataset.money, form = $('[data-nv-form]', root), vid = $('[data-nv-vid]', root);
    var variants = []; try { variants = JSON.parse($('[data-nv-variants]', root).textContent); } catch (e) {}
    var track = $('[data-nv-track]', root), thumbs = $$('[data-nv-thumb]', root), cnt = $('[data-nv-cnt]', root);
    function show(i, smooth) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * i, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i, true); }); });
    if (track) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (cnt) cnt.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }, { passive: true });

    function current() {
      var sel = $$('[data-nv-opt]', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      return variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
    }
    function paint(v) {
      var atc = $$('[data-nv-atc],[data-nv-sb-atc],[data-nv-buynow]', root);
      if (!v) { atc.forEach(function (b) { b.disabled = true; var s = $('span', b); if (s) s.textContent = 'Unavailable'; }); return; }
      vid.value = v.id;
      var pr = $('[data-nv-price]', root), save = v.compare_at_price > v.price;
      $('.nv-price', pr).textContent = money(v.price, fmt);
      $('.nv-was', pr).textContent = save ? money(v.compare_at_price, fmt) : ''; $('.nv-was', pr).hidden = !save;
      $('.nv-save', pr).textContent = save ? 'You save ' + money(v.compare_at_price - v.price, fmt) : ''; $('.nv-save', pr).hidden = !save;
      var sp = $('[data-nv-sb-price]', root), sw = $('[data-nv-sb-was]', root);
      if (sp) sp.textContent = money(v.price, fmt);
      if (sw) { sw.textContent = save ? money(v.compare_at_price, fmt) : ''; sw.hidden = !save; }
      atc.forEach(function (b) { b.disabled = !v.available; var s = $('span', b); if (s) s.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (v.featured_media) { var k = thumbs.findIndex(function (t) { return t.dataset.media == v.featured_media.id; }); if (k > -1) show(k, true); }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      // grey out values that cannot be bought with the other picks
      $$('[data-nv-opt]', root).forEach(function (f, i) {
        $$('label', f).forEach(function (l) {
          var val = $('input', l).value;
          var ok = variants.some(function (x) { return x.available && x.options[i] === val && x.options.every(function (o, j) { return j === i || o === v.options[j]; }); });
          l.classList.toggle('is-na', !ok);
        });
      });
    }
    root.addEventListener('change', function (e) {
      var f = e.target.closest('[data-nv-opt]'); if (!f) return;
      var lab = $('[data-nv-opt-val]', f); if (lab) lab.textContent = e.target.value;
      paint(current());
    });
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-nv-step]'); if (!s) return;
      var q = $('[data-nv-qtyin]', root); q.value = Math.max(1, (Number(q.value) || 1) + Number(s.dataset.nvStep));
    });
    function add(btn) {
      var q = Math.max(1, Number($('[data-nv-qtyin]', root).value) || 1);
      return addToCart([{ id: Number(vid.value), quantity: q }], btn).catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add this item'); throw err; });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add($('[data-nv-atc]', root)); });
    var sb = $('[data-nv-sb-atc]', root); if (sb) sb.addEventListener('click', function () { add(sb); });
    var bn = $('[data-nv-buynow]', root);
    if (bn) bn.addEventListener('click', function () {
      bn.classList.add('is-loading');
      var q = Math.max(1, Number($('[data-nv-qtyin]', root).value) || 1);
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid.value), quantity: q }] }) })
        .then(function (r) { if (!r.ok) throw r; location.href = ROOT + 'checkout'; })
        .catch(function () { bn.classList.remove('is-loading'); toast('Could not start checkout'); });
    });
    // sticky mobile buy bar appears once the main button scrolls away
    var bar = $('[data-nv-sbuy]', root), main = $('[data-nv-atc]', root);
    if (bar && main && 'IntersectionObserver' in window) {
      document.body.classList.add('nv-has-sbuy-ready');
      new IntersectionObserver(function (es) { var off = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; bar.classList.toggle('is-on', off); document.body.classList.toggle('nv-has-sbuy', off); }).observe(main);
    }
    if (variants.length > 1) paint(current());
  }

  function recs(el) {
    if (el.__nv || !el.dataset.nvRecs) return; el.__nv = 1;
    fetch(el.dataset.nvRecs).then(function (r) { return r.text(); }).then(function (t) {
      var fresh = $('[data-nv-recs]', parse(t)); if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------- policy pages get the help-centre layout ---------- */
  function policy() {
    var c = $('.shopify-policy__container'), tpl = $('#nv-help-tpl');
    if (!c || !tpl || c.__nv) return; c.__nv = 1;
    var shell = document.createElement('div'); shell.className = 'nv';
    shell.innerHTML = '<div class="nv-wrap"><div class="nv-help"><div data-nav></div><article class="nv-art nv-pol"></article></div></div>';
    c.parentNode.insertBefore(shell, c);
    $('[data-nav]', shell).replaceWith(tpl.content.cloneNode(true));
    $('article', shell).appendChild(c);
    var facts = $('#nv-facts-tpl'), title = $('.shopify-policy__title', c);
    if (facts && title) title.after(facts.content.cloneNode(true));
  }

  /* ---------- scroll: hide the app bar going down, keep sticky bars under the header ---------- */
  var lastY = window.scrollY, hd;
  function onScroll() {
    var y = window.scrollY;
    if (Math.abs(y - lastY) > 6) { html.classList.toggle('nv-down', y > lastY && y > 160); lastY = y; }
  }
  function measure() {
    hd = hd || $('[data-nv-header]');
    var stuck = hd && hd.classList.contains('is-stuck');
    html.style.setProperty('--nv-stick', stuck ? hd.offsetHeight + 'px' : '0px');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);

  /* ---------- per-section setup ---------- */
  function init(root) {
    root = root || document;
    measure();

    $$('[data-nv-rotate]', root).forEach(function (el) {
      if (el.__nv) return; el.__nv = 1;
      var msgs = $$('.nv-ann__msg', el); if (msgs.length < 2 || reduce) return;
      var i = 0, ms = (parseInt(el.dataset.nvRotate, 10) || 4) * 1000;
      setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, ms);
    });

    $$('[data-nv-hints]', root).forEach(function (inp) {
      if (inp.__nv || reduce) return; inp.__nv = 1;
      var h = inp.dataset.nvHints.split('|').map(function (x) { return x.trim(); }).filter(Boolean); if (h.length < 2) return;
      var i = 0; setInterval(function () { if (document.activeElement === inp) return; i = (i + 1) % h.length; inp.placeholder = h[i]; }, 2800);
    });

    // department filter on the all-collections section
    $$('[data-nv-filter-host]', root).forEach(function (host) {
      if (host.__nv) return; host.__nv = 1;
      host.addEventListener('click', function (e) {
        var b = e.target.closest('[data-nv-dept]'); if (!b) return;
        $$('[data-nv-dept]', host).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        var d = b.dataset.nvDept;
        $$('.nv-circ[data-dept]', host).forEach(function (c) { c.hidden = d !== 'all' && c.dataset.dept !== d; });
      });
    });

    // older tab sections kept for the theme editor
    $$('[data-nv-tabs-host]', root).forEach(function (host) {
      if (host.__nv) return; host.__nv = 1;
      host.addEventListener('click', function (e) {
        var b = e.target.closest('[data-nv-tab]'); if (!b || !host.contains(b)) return;
        var i = b.getAttribute('data-nv-tab');
        $$('[data-nv-tab]', host).forEach(function (x) { var on = x.getAttribute('data-nv-tab') === i; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        $$('[data-nv-panel]', host).forEach(function (p) { p.hidden = p.getAttribute('data-nv-panel') !== i; });
        $$('[data-nv-swap]', host).forEach(function (el) { try { el.textContent = JSON.parse(el.getAttribute('data-nv-swap'))[i]; } catch (err) {} });
        $$('[data-nv-href]', host).forEach(function (el) { try { el.href = JSON.parse(el.getAttribute('data-nv-href'))[i]; } catch (err) {} });
      });
    });

    $$('[data-nv-feed]', root).forEach(feed);
    $$('[data-nv-plp]', root).forEach(function (h) { loader(h); });
    if ($('.nv-srp', root)) loader($('.nv-srp', root).parentNode);
    $$('[data-nv-pdp]', root).forEach(pdp);
    $$('[data-nv-recs]', root).forEach(recs);

    // sort select reloads the collection with the new order
    $$('[data-nv-sort]', root).forEach(function (s) {
      if (s.__nv) return; s.__nv = 1;
      var lab = s.parentNode.querySelector('[data-nv-sort-label]');
      if (lab && s.selectedOptions[0]) lab.textContent = s.selectedOptions[0].text;
      s.addEventListener('change', function () { location.href = withParam(location.href, 'sort_by', s.value).replace(/([?&])page=\d+&?/, '$1'); });
    });

    var rev = $$('.nv-reveal:not(.is-in)', root);
    if (rev.length) {
      if (reduce || !('IntersectionObserver' in window)) rev.forEach(function (el) { el.classList.add('is-in'); });
      else {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
        rev.forEach(function (el) { io.observe(el); });
      }
    }
    policy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  window.addEventListener('load', measure);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
